import React, { useCallback } from 'react'
import AsyncSelect from 'react-select/async'

import { formatValue } from '../../../../utils/formatting'
import * as API from '../../../../utils/api'
import Icon from '../../Icon'

import styles from './SearchInput.module.css'

const log = name => (provided, state) => {
  console.log(name, '-->', provided, state)

  return provided
}

const customStyles = error => {
  const borderColor = error ? '#d00' : '#0038ff'

  return {
    container: log('container'),
    control: (provided, { isFocused }) => ({
      ...provided,
      borderRadius: 0,
      borderStyle: 'none',
      borderBottomStyle: 'solid',
      borderColor: error
        ? '#d00 !important'
        : isFocused
        ? '#0038ff !important'
        : '#e0e0e0 !important',
      boxShadow: isFocused || error ? `0 1px ${borderColor}` : 'none',
    }),
    valueContainer: provided => ({
      ...provided,
      paddingLeft: 0,
      height: 45,
      cursor: 'text',
    }),
    placeholder: provided => ({
      ...provided,
      marginLeft: 36,
      fontSize: 20,
      fontWeight: 600,
      color: '#bbb',
    }),
    singleValue: provided => ({
      ...provided,
      marginLeft: 36,
      fontSize: 20,
      fontWeight: 600,
    }),
    input: provided => ({
      ...provided,
      marginLeft: 36,
      font: 'inherit',
      fontSize: 20,
      fontWeight: 600,
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: () => ({
      display: 'none',
    }),
  }
}

export default function SearchInput({
  label,
  databaseId,
  table,
  input,
  meta,
  ...props
}) {
  const loadOptions = useCallback(
    async query => {
      let result = await API.searchRecords(databaseId, table.name, query)

      return result.data.map(itm => {
        let result = {
          label: Object.keys(itm)
            .filter(key => key !== '__pk')
            .map(key => itm[key])
            .map(val => formatValue(val))
            .join(' - '),
          value: itm.__pk,
        }

        return result
      })
    },
    [databaseId, table]
  )

  const handleBlur = useCallback(() => {
    input.onBlur(input.value)
  }, [input.onBlur, input.value])

  const { error: hasError, touched } = meta

  const error = touched ? hasError : undefined

  console.log('VALUE:', input)

  return (
    <div className={styles.wrapper}>
      <label>{label}</label>
      <div className={styles.input}>
        <div className={styles.icon}>
          <Icon icon="search" color="grey" />
        </div>
        <AsyncSelect
          {...props}
          value={input.value}
          onChange={input.onChange}
          onFocus={input.onFocus}
          onBlur={handleBlur}
          loadOptions={loadOptions}
          styles={customStyles(error)}
        />
      </div>
      {error && <p className={styles.errorMessage}>{error}</p>}
    </div>
  )
}
